import React, { useState } from 'react';
import { Link, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import DownloadCTA from '../components/app/DownloadCTA';

const Logo = () => (
  <div className="flex items-center gap-1">
    <span className="text-white font-black text-3xl tracking-tight lowercase">
      adqui<span className="text-[#A3FF12]">riam</span>
    </span>
    <svg width="22" height="22" viewBox="0 0 24 24" className="text-[#A3FF12] ml-0.5" fill="none">
      <path d="M4 4h16M4 12h16M4 20h10" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    </svg>
  </div>
);

const Login = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/app" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/app');
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(163,255,18,0.08),transparent_50%)] pointer-events-none"/>
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-10"><Logo /></div>
        <div className="bg-[#0a0a0a] border border-white/10 rounded-3xl p-8">
          <h1 className="text-3xl font-black text-white">Iniciar sesión</h1>
          <p className="text-white/50 text-sm mt-2">Acceso al panel de gestión.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-white/80 text-sm font-semibold">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-1 bg-black border border-white/15 text-white rounded-xl px-4 py-3 focus:outline-none focus:border-[#A3FF12]" placeholder="tu@empresa.com"/>
            </div>
            <div>
              <label className="text-white/80 text-sm font-semibold">Contraseña</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-1 bg-black border border-white/15 text-white rounded-xl px-4 py-3 focus:outline-none focus:border-[#A3FF12]" placeholder="••••••••"/>
            </div>
            {err && <div className="bg-red-500/10 border border-red-500/30 text-red-300 text-sm rounded-lg px-3 py-2">{err}</div>}
            <button type="submit" disabled={loading}
              className="w-full bg-[#A3FF12] text-black font-black py-3 rounded-xl hover:bg-[#b8ff3a] transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              {loading && <Loader2 className="animate-spin" size={18}/>} Entrar
            </button>
          </form>
          <div className="text-white/50 text-sm mt-6 text-center">
            ¿No tienes cuenta? <Link to="/register" className="text-[#A3FF12] font-semibold hover:underline">Regístrate</Link>
          </div>
        </div>
        <p className="text-white/30 text-xs text-center mt-6">Gestión de emplazamientos para operadores de telecomunicaciones</p>

        <DownloadCTA/>
      </div>
    </div>
  );
};

export default Login;
